import { render, staticRenderFns } from "./LocationLicenseChangeListDataTable.vue?vue&type=template&id=4a30cc42&"
import script from "./LocationLicenseChangeListDataTable.vue?vue&type=script&lang=js&"
export * from "./LocationLicenseChangeListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./LocationLicenseChangeListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports